/* eslint-disable no-unused-vars */
import React from 'react';

import TopicContainer from '../../components/TopicContainer';
import TopicItem from '../../components/TopicItem';
import './index.less';
import './index.en.less';
import Section0 from './section0';
import Section1 from './section1';
import Section2 from './section2';
// import Section3 from './section3';

interface ITopic900Props {
  settings: any;
}

const TopicNetworkRiskReview: React.FunctionComponent<ITopic900Props> = ({
  settings,
}) => (
  <TopicContainer className="networkRiskReview">
    <TopicItem id="1">
      <Section0 settings={settings} />
    </TopicItem>
    <TopicItem className="topic-item networkRiskReview_1" id="2">
      <Section1 settings={settings} />
    </TopicItem>
    {/* <TopicItem className="topic-item networkRiskReview_2" id="3">
      <Section2 settings={settings} />
    </TopicItem> */}
    <TopicItem className="topic-item networkRiskReview_2" id="3">
      <Section2 settings={settings} />
    </TopicItem>
    {/* <TopicItem className="topic-item networkRiskReview_3" id="4">
      <Section3 settings={settings} />
    </TopicItem> */}
  </TopicContainer>
);

export default TopicNetworkRiskReview;
